  // const BaseUrl = "http://campusshala.com:3009" 
//  const BaseUrl = "http://localhost:15002" 
 //  const BaseUrl = "http://192.168.1.21:15002" 
 const BaseUrl = "http://localhost:3000";
export default BaseUrl;